import { formatTime } from '../../utils/Shipment';
import { CURRENCY_SYMBOL } from '../../constants/constants';
import _find from 'lodash/find';

export const tableColumnExtensions = [
  { columnName: 'displayId', width: 120 },
  { columnName: 'variance', width: 85 },
  { columnName: 'quoted', width: 85 },
  { columnName: 'displayShipmentId', width: 120 },
  { columnName: 'invoiced', width: 85 },
  { columnName: 'actualDelivery', width: 100 },
  { columnName: 'dueDate', width: 100 }
];

export const columns = t => {
  return [
    {
      title: t('Invoice Number'),
      name: 'displayId'
    },
    {
      title: t('Shipment Number'),
      name: 'displayShipmentId'
    },
    {
      title: t('Variance'),
      name: 'variance'
    },
    {
      title: t('Quoted'),
      name: 'quoted'
    },
    {
      title: t('Invoiced'),
      name: 'invoiced'
    },
    {
      title: t('Carrier'),
      name: 'carrierName'
    },
    {
      title: t('Delivery Date'),
      name: 'actualDelivery'
    },
    {
      title: t('Due Date'),
      name: 'dueDate'
    },
    {
      title: t('Status'),
      name: 'displayStatus'
    }
  ];
};

const invoiceStatuses = [
  { name: 'In Review', enumValue: 'IN_REVIEW' },
  { name: 'Rejected', enumValue: 'REJECTED' },
  { name: 'Parsing Error', enumValue: 'PARSING_ERROR' },
  { name: 'Disputed', enumValue: 'DISPUTED' },
  { name: 'Awaiting Documents', enumValue: 'AWAITING_DOCUMENTS' },
  { name: 'Ready to Remit', enumValue: 'READY_TO_REMIT' },
  { name: 'Processed', enumValue: 'PROCESSED' },
  { name: 'Awaiting Revision', enumValue: 'AWAITING_REVISION' }
];

export const formatVariance = (invoiced, quoted, defaultCurrency) => {
  // We have several scenarios to deal with:
  // 1) There is no quoted price (shipment not assigned) - in this cases variance is '--'
  // 2) There is no invoiced price (invoice not assigned) - variance is '--'
  // 3) Invoiced = quoted : variance is "None"
  // 4) Invoiced > quoted : variance shows prefix of +
  // 5) Invoiced < quoted : variance shows prefix of -

  if (!invoiced || !quoted) {
    return '--';
  }

  if (invoiced === quoted) {
    return 'None';
  }

  const variance = invoiced - quoted;
  let prefix = `+ ${CURRENCY_SYMBOL[defaultCurrency]}`;
  if (variance < 0) {
    prefix = `- ${CURRENCY_SYMBOL[defaultCurrency]}`;
  }
  return `${prefix}${Math.abs(variance).toFixed(2)}`;
};

const convertStatus = status => {
  return _find(invoiceStatuses, { enumValue: status }).name;
};

export const formatInvoice = (row, defaultCurrency) => {
  const invoice = {
    id: row.id,
    displayId: row.id ? row.id : '--',
    shipmentId: row.shipmentId,
    displayShipmentId: row.shipmentId ? row.shipmentId : '--',
    variance: formatVariance(row.invoiced, row.quoted, defaultCurrency),
    quoted: row.quoted
      ? `${CURRENCY_SYMBOL[defaultCurrency]}${row.quoted.toFixed(2)}`
      : '--',
    invoiced: row.invoiced
      ? `${CURRENCY_SYMBOL[defaultCurrency]}${row.invoiced.toFixed(2)}`
      : '--',
    showAsException: row.showAsException,
    carrierName: row.carrierName,
    carrierInvoiceNumber: row.carrierInvoiceNumber,
    actualDelivery: row.actualDelivery ? formatTime(row.actualDelivery) : '--',
    invoiceDate: row.invoiceDate ? formatTime(row.invoiceDate) : '--',
    dueDate: row.dueDate ? formatTime(row.dueDate) : '--',
    status: row.status,
    displayStatus: row.status ? convertStatus(row.status) : '--'
  };

  return invoice;
};

//TODO - will change once data model is defined on the backend
export const formatInvoices = (invoices, defaultCurrency) =>
  invoices.map(row => {
    return formatInvoice(row, defaultCurrency);
  });
